var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #86c5b9;\n      }\n\n      .cls-3 {\n        fill: #086f7f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.15,217.7h109.7c7.81,0,14.15-6.33,14.15-14.15V52.45c0-7.81-6.33-14.15-14.15-14.15H73.15c-7.81,0-14.15,6.33-14.15,14.15V203.55c0,7.81,6.33,14.15,14.15,14.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.56,78.86h96.88c3.73,0,6.76-3.03,6.76-6.76v-13.24c0-3.73-3.03-6.76-6.76-6.76H79.56c-3.73,0-6.76,3.03-6.76,6.76v13.24c0,3.73,3.03,6.76,6.76,6.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.01,121.1h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.61,121.1h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.21,121.1h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.01,162.5h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.61,162.5h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.21,162.5h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.01,203.9h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.61,203.9h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.21,203.9h14.78c3.54,0,6.41-2.87,6.41-6.41v-14.78c0-3.54-2.87-6.41-6.41-6.41h-14.78c-3.54,0-6.41,2.87-6.41,6.41v14.78c0,3.54,2.87,6.41,6.41,6.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmi);
export default __webpack_public_path__ + "static/media/bmi.55d3f0a38d9cfdceb4962a889b62f2ab.svg";
export { ForwardRef as ReactComponent };